import { createAction, props } from '@ngrx/store';

export const actionToggleTool = createAction(
  '[Sidebar] Toggle tool',
  props<{ payload: string }>(),
);

export const actionCloseSidebar = createAction('[Sidebar] Close sidebar');
